import React, { useState } from 'react'
import { RoundCard, RunnerUpHeader, TableWork } from '../../../ui'
import SelectField from '../../../library/components/Select'

import { Validators } from '../../../library/utilities/Validator'
import {
  FILED_IS_REQUIRED,
  NO_RECORDS_FOUND,
  APPROVE,
  REJECT,
  FILL_ALL_FIELDS,
} from '../../../constants/constants'

import './viewEpb.css'
import {
  useGetConstituencyRequestQuery,
  useGetPcByStateQuery,
} from '../../../services/announceElection'
import { useGetEpbGenStatusMutation } from '../../../services/finalizeGenerateViewTransmitService'
import { parseJwt } from '../../utilities/utils'
import { Link } from 'react-router-dom'
import { useGetObjectStoreFileQuery } from '../../../services/objectStoreServices'
import { IndexOutOfBoundsError } from 'pdf-lib'
import { useEffect } from 'react'
import LeftMenu from '../../AnalyticsModule/Left'
import Table from "../../../ui/datatable/DataTable";
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew'

const tableHeader = ['Constituency Type', 'Constituency Number & Name', 'View']
const ConstType = [
  { label: 'AC', value: 'AC' },
  { label: 'PC', value: 'PC' },
]
const Status = [
  { label: 'Select Status', value: '' },
  { label: 'In-Progress', value: 'N' },
  { label: 'Generated', value: 'Y' },
]

//ViewE_PbByCeo
const ViewEpbByCEO = () => {
  const [Data, setData] = useState({})
  const [state ,setState]=useState()
  const [totalNoOfRecords,setTotalNoOfRecords]=useState()
  const [errorValue, setErrorValue] = useState({})
  const [Error, setError] = useState({})
  const [Path, setPath] = useState('')
  const StateCd = parseJwt(localStorage.access_token).authorizedStates?.[0]
  const { data: Acdata } = useGetConstituencyRequestQuery(StateCd, {
    skip: Data.SelectedConstType === 'AC' ? false : true,
  })
  const { data: Pcdata } = useGetPcByStateQuery(StateCd, {
    skip: Data.SelectedConstType === 'PC' ? false : true,
  })
  const [getdata, datap] = useGetEpbGenStatusMutation()
  const { data: GetUploadPath } = useGetObjectStoreFileQuery(Path, {
    skip: Path === '' ? true : false,
  })
  const ConstList = [{ value: '', label: 'Select Const. Name' }]
  const [tabledata, setTabledata] = useState([])

  const tableHeader = [];
  const columns = [
    {
      Header: "Constituency Type",
      accessor: "Constituency Type",
    },
    {
      Header: "Constituency Number & Name",
      accessor: "Constituency Number & Name",
    },
    {
      Header: "Ballot Paper",
      accessor: "View_ballot",
    },
    {
      Header: "e-PB Paper",
      accessor: "View_epb",
    },
  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })


  if (Data.SelectedConstType === 'AC') {
    Acdata?.map((item) => {
      ConstList.push({
        label: `${item.asmblyNo} - ${item.asmblyName}`,
        value: item.asmblyNo,
      })
    })
  }
  if (Data.SelectedConstType === 'PC') {
    Pcdata?.map((item) => {
      ConstList.push({
        label: `${item.prlmntNo} - ${item.parliamentName}`,
        value: item.prlmntNo,
      })
    })
  }

  useEffect(() => {
    const tableData = []
    if (datap.isSuccess) {
      datap?.data?.payload?.map((item) => {
        tableData.push({
          'Constituency Type': item.constType,
          'Constituency Number & Name': `${item.constNo} - ${item.constName} `,
          View_ballot:
            item.epbPinGenerated === "Y" ? (
              <Link to={''} onClick={() => setPath(item.ballotPaperPath)}>
               e-PB Transmitted
              </Link>
            ) : item.epbPinGenerated !== "Y" && item.ballotPaperPath=== null ? (
              <Link to={''} >
               Yet to be uploaded
              </Link>
            ):item.epbPinGenerated !== "Y" && item.ballotPaperPath!== ""? (
              <Link to={''}  onClick={() => setPath(item.ballotPaperPath)} >
                Ballot uploaded
              </Link>):null,
            View_epb: 
            item.epbPinGenerated === "Y" ? (
              <Link to={''} onClick={() => setPath(item.epbPaperPath)}>
               e-PB Transmitted
              </Link>
            ) : item.epbPinGenerated !== "Y" && item.epbPaperPath=== null ? (
              <Link to={''} >
              Yet to be generated
              </Link>
            ):item.epbPinGenerated !== "Y" && item.epbPaperPath!== ""? (
              <Link to={''}  onClick={() => setPath(item.epbPaperPath)} >
                e-PB Finalized
              </Link>):null, 
        })
      })
      setState(datap?.data?.state)
      setTabledata(tableData)
      setTotalNoOfRecords(datap?.data?.payload?.length)
    }
  }, [datap.isSuccess])

  const handleChange = (key, value, key2, value2) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
      [key2]: value2,
    }))
  }

  const getErrorValue = (key, value) => {
    let error = { ...Error }
    if (value && value.message) {
      setError({ ...Error, [key]: value.message })
    } else {
      delete error[key]
      setError(error)
    }
  }

  const onFetch = () => {
    // let error = {}
    // if (!Data.SelectedConstType || Data.SelectedConstType === '') {
    //   error['Selected Const. Type'] = 'This field is required'
    // }
    // if (!Data.SelectedConstNo || Data.SelectedConstNo === '') {
    //   error['Selected Const. Name'] = 'This field is required'
    // }
    // if (!Data.SelectedStatus || Data.SelectedStatus === '') {
    //   error['Selected Status'] = 'This field is required'
    // }
    // if (Object.keys(error).length) {
    //   setError(error)
    //   return
    // }
   
  }
  useEffect(()=>{
    if(Data.SelectedConstType!==null || Data.SelectedConstType!==undefined || Data.SelectedConstType!=="")
    {
      getdata({
        constType: Data.SelectedConstType,
        constNo: Data.SelectedConstNo,
        epbPinGen: Data.SelectedStatus,
      })
    }
  },[Data.SelectedConstType])

  function base64ToBlob(base64, type = 'application/octet-stream') {
    const binStr = atob(base64)
    const len = binStr.length
    const arr = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i)
    }
    return new Blob([arr], { type: type })
  }

  useEffect(() => {
    if (GetUploadPath) {
      const blob = base64ToBlob(GetUploadPath.file, 'application/pdf')
      if (blob) {
        var win = window.open()
        win.document.write(
          '<iframe src="' +
            `${URL.createObjectURL(blob)}` +
            '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>',
        )
      }
      setPath('')
    }
  }, [GetUploadPath])

  return (
    <LeftMenu>
      <div className="approval-epb container-fluid box shadow ">
        <div className="ml-1 mr-1 ">
          <RunnerUpHeaderNew title={'e-PB Generation Status'}
             state={ <span
                  >
                    State: {state}{" "}
                    </span>}
              />
        </div>
        <div className="row mr-1">
          <div className="col-md-3 ml-2 mt-1">
            <label>Select Constituency Type</label>
          </div>
          <div className="col-md-3 row">
            {/* <Select disabled={true} placeholder={"Select Const. Type"} list={[{ value: "", label: "" }]} selectClass='select-class' /> */}
            <SelectField
              labelClass=""
              placeholder={'Select Const. Type'}
              inputClass="col-md-6"
              name="Selected Const. Type"
              options={ConstType}
              value={Data.SelectedConstType}
              handleChange={(val) => handleChange('SelectedConstType', val)}
              getError={(value) => getErrorValue('Selected Const. Type', value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
              ]}
              Error={Error}
              seterror={setError}
            ></SelectField>
            {/* <SelectField
              labelClass=""
              placeholder={'Select Const. Name'}
              inputClass="col-md-3"
              name="Selected Const. Name"
              options={ConstList.sort((a, b) => a.value - b.value)}
              value={Data.SelectedConstNo}
              handleChange={(val, label) =>
                handleChange('SelectedConstName', label, 'SelectedConstNo', val)
              }
              getError={(value) => getErrorValue('Selected Const. Name', value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
              ]}
              Error={Error}
              seterror={setError}
            ></SelectField> */}

            {/* <SelectField
              labelClass=""
              placeholder={'Select Status'}
              inputClass="col-md-3"
              name="Selected Status"
              options={Status}
              value={Data.SelectedStatus}
              handleChange={(val) => handleChange('SelectedStatus', val)}
              getError={(value) => getErrorValue('Selected Status', value)}
              validators={[
                {
                  check: Validators.required,
                  message: FILED_IS_REQUIRED,
                },
              ]}
              Error={Error}
              seterror={setError}
            ></SelectField> */}

            {/* <Select disabled={true} placeholder={"Select Const. Name"} list={[{ value: "", label: "" }]} selectClass='select-class' />
                        <Select disabled={true} placeholder={"Select Status"} list={[{ value: "", label: "" }]} selectClass='select-class' /> */}
            {/* <Link to="ro/finalepb" className='button-link'>View</Link> */}
            {/* <div className="request-button mt-0 ">
              <button className="button" onClick={onFetch}>
                View
              </button>
            </div> */}
          </div>
        </div>

        {/* <TableWork
          id=""
          theadData={tableHeader}
          tbodyData={tabledata}
          anchorTagName=""
          anchorTagclassName="viewDetails"
          emptyMessage="No data found"
          pageSize={10}
          pagination={true}
          paginationClass={'text-right p-0'}
        /> */}
        <div>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns}
          emptyMessage="No Record Found"
          data={tabledata?.length === 0 ? [] : tabledata}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
        </div>
        
      </div>
    </LeftMenu>
  )
}

export default ViewEpbByCEO
